import type { Route } from '@angular/router';
import { dirtyCheckCanDeactivateGuard } from '../../common/dirty-check/dirty-check';
import { hasUuidPathParamCanActivateGuard } from '@pct/ng-core-router';

function i18nPrefix(name: string): string {
  return `PAGES.ADMIN_USER.${name}.BREADCRUMB`;
}
export const adminUserRoutes: Route[] = [
  {
    path: '',
    loadComponent: () =>
      import('./list/admin-user-list.component').then(
        ({ AdminUserListComponent }) => AdminUserListComponent,
      ),
    pathMatch: 'full',
  },
  {
    path: 'invite',
    loadComponent: () => import('./details/admin-user-details.component'),
    title: i18nPrefix('NEW_INVITATION'),
    canDeactivate: [dirtyCheckCanDeactivateGuard('HasDirtyCheck')],
  },
  {
    path: ':id',
    loadComponent: () => import('./details/admin-user-details.component'),
    title: i18nPrefix('DETAILS'),
    canActivate: [hasUuidPathParamCanActivateGuard('id')],
    canDeactivate: [dirtyCheckCanDeactivateGuard('HasDirtyCheck')],
  },
  {
    path: '**',
    redirectTo: '',
  },
];
